

export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      width: 50,
      slot: 'index',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '博物馆名称',
      width: '300px'
    },
    {
      key: 'province',
      dataIndex: 'province',
      title: '省份',
    },
    {
      key: 'applylevel',
      dataIndex: 'applylevel',
      title: '申报等级',
    },
    {
      key: 'newlevel',
      dataIndex: 'newlevel',
      title: '成绩',
    },
    {
      key: 'score',
      dataIndex: 'score',
      title: '得分',
    },
    {
      key: 'scorerank',
      dataIndex: 'scorerank',
      title: '排名',
    },
    {
      width: 100,
      slot: 'operate',
      title: '操作',
    },
    {
      title: '评分详情',
      width: 100,
      slot: 'detail',
    },
  ],
  tHead1: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      width: 50,
      slot: 'index',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '博物馆名称',
      width: '300px'
    },
    {
      key: 'province',
      dataIndex: 'province',
      title: '省份',
    },
    {
      key: 'applylevel',
      dataIndex: 'applylevel',
      title: '申报等级',
    },
    {
      key: 'newlevel',
      dataIndex: 'newlevel',
      title: '成绩',
    },
    {
      key: 'score',
      dataIndex: 'score',
      title: '得分',
    },
    {
      width: 100,
      slot: 'operate',
      title: '操作',
    },
    {
      title: '评分详情',
      width: 100,
      slot: 'detail',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
